/**
 * Service layer for the Proposal DeficienciesStep (task-06).
 *
 * Uses apiClient (axios-case-converter) so camelCase keys are automatically
 * serialised as snake_case for Rails and responses are deserialised back to
 * camelCase — matching the ProposalDeficiencyApiRow contract.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClient from '@utils/api-client';
import { DEFAULT_DEFICIENCY_FILTERS } from '../types';
function filterQueryParams(filters) {
    const params = {};
    if (filters.dateOpenedFrom)
        params.dateOpenedFrom = filters.dateOpenedFrom;
    if (filters.dateOpenedTo)
        params.dateOpenedTo = filters.dateOpenedTo;
    if (filters.systemAssets.length > 0)
        params.assets = filters.systemAssets.join(',');
    if (filters.severity)
        params.severity = filters.severity;
    return params;
}
export function fetchLinkedDeficiencies(proposalId_1) {
    return __awaiter(this, arguments, void 0, function* (proposalId, filters = DEFAULT_DEFICIENCY_FILTERS) {
        const params = filterQueryParams(filters);
        const response = yield apiClient.get(`/proposals/${proposalId}/linked_deficiencies`, {
            params
        });
        return response.data;
    });
}
/**
 * Rails returns `{ deficiencies, total, page, perPage }`. The Add overlay
 * maps the service result with `.map()`, so callers always receive an array.
 */
export function unwrapCandidateDeficiencies(data) {
    if (Array.isArray(data))
        return data;
    if (data && Array.isArray(data.deficiencies))
        return data.deficiencies;
    return [];
}
export function fetchCandidateDeficiencies(proposalId, filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.get(`/proposals/${proposalId}/deficiency_candidates`, { params: filterQueryParams(filters) });
        return unwrapCandidateDeficiencies(response.data);
    });
}
export function linkDeficiencies(proposalId, deficiencyIds) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.post(`/proposals/${proposalId}/link_deficiencies`, { deficiencyIds });
    });
}
export function unlinkDeficiency(proposalId, deficiencyId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/proposals/${proposalId}/unlink_deficiencies`, {
            data: { deficiencyIds: [deficiencyId] }
        });
    });
}
export function toggleDeficiencyPhotos(proposalId, deficiencyId, include) {
    return __awaiter(this, void 0, void 0, function* () {
        const endpoint = include ? 'include_deficiency_photos' : 'exclude_deficiency_photos';
        yield apiClient.put(`/proposals/${proposalId}/${endpoint}`, null, {
            params: { deficiencyId }
        });
    });
}
